// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".seller-center-title[data-v-46148294]{display:flex;align-items:center;border-bottom:1px solid #dcdee2;padding-bottom:5px;margin-bottom:15px}.title-text[data-v-46148294]{flex:1}h2[data-v-46148294]{border:none;margin-bottom:0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
